import { graphql } from '@search/gql-client/src';

export const AgentGetCustomersQuery = graphql`
    query AgentGetCustomersQuery {
        agent {
            searchesList {
                customerId
                searchesCount
                searches {
                    id
                    title
                    added
                    query
                    subscription {
                        emails
                    }
                }
            }
            favoritesList {
                customerId
                favoritesCount
                favorites {
                    added
                    offerId
                }
            }
            customersList {
                id
                name
                note
                phone
                email
                created
                updated
            }
        }
    }
`;
